<!-- TEMPLATE -->
<template>
  <div class="content" style="padding-top: 0px">
    <div class="card">
      <div class="card-header">
        <h5 class="title">No settings needed for this plugin</h5>
      </div>
    </div>

    <v-layout row justify-center align-center>
      <v-icon align="middle" size="250" color="green">
        mdi-check-circle
      </v-icon>
    </v-layout>
  </div>
</template>


<!-- SCRIPT -->
<script>
export default {
  name: "NoPluginSettings",
  data: function () {
    return {};
  },
  created() {},
  computed: {},
  methods: {},
  filters: {},
  components: {},
};
</script>

<!-- Style -->
<style>
</style>